import { render } from "./ThemeToggler.vue?vue&type=template&id=5974d745"
import script from "./ThemeToggler.vue?vue&type=script&lang=js"
export * from "./ThemeToggler.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__